import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Banner, Pagination, Query } from '@deckplan.io/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlUtils } from '../common/utils/url-utils';
import { Mockable } from '../mocks/mockable.decorator';

export interface BannersAndTotalCount {
    totalCount: number;
    banners: Banner[];
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class BannerService {

    private readonly backendUrl = UrlUtils.constructBackendUrl('moderation/banner');

    constructor(private readonly http: HttpClient) {}

    public getAll(pagination: Partial<Pagination> = null, query: Query = null): Observable<BannersAndTotalCount> {
        const url = UrlUtils.constructPaginationAndFilterUrl(this.backendUrl, pagination, query);

        return this.http.get(url, {observe: 'response'})
            .pipe(
                map(res => ({totalCount: parseInt(res.headers.get('total-count'), 10), banners: res.body as any}))
            );
    }

    public getOne(id: number): Observable<Banner> {
        return this.http.get<Banner>(`${this.backendUrl}/${id}`);
    }

    public getActiveForUser(userId: number): Observable<Banner[]> {
        return this.http.get<Banner[]>(`${this.backendUrl}/user/${userId}`);
    }

    public create(banner: Banner): Observable<Banner> {
        return this.http.post<Banner>(`${this.backendUrl}`, banner);
    }

    public update(id: number, updates: Partial<Banner>): Observable<Banner> {
        return this.http.put<Banner>(`${this.backendUrl}/${id}`, updates);
    }

    public delete(id: number): Observable<Banner> {
        return this.http.delete<Banner>(`${this.backendUrl}/${id}`);
    }
}
